import type { AbstractControl, AbstractControlOptions } from '@angular/forms';

export enum FormStatus {
  INITIAL,
  LOADING,
  COMPLETE,
  AY_COMPLETE,
  ERROR,
  REFUND_CASE_NOT_SUPPORTED,
  INITIALIZING,
  INITIALIZING_ERROR,
}

export enum AnalyticsFormStatus {
  ERROR = 'error',
  INCIDENT_UPDATES = 'incident-updates',
  PHASE1_ERROR = 'phase1-error',
  PHASE1_SEND_ATTEMPT = 'phase1-send-attempt',
  PHASE1_SUCCESS = 'phase1-success',
  CASE_ATTACHMENT_ERROR = 'case-attachment-error',
  SEND_ATTEMPT = 'send-attempt',
  START = 'start',
  SUCCESS = 'success',
}

export enum FormError {
  LAST_NAME_MISMATCH = 'last-name-mismatch',
  ERROR = 'error',
}

export enum ReactiveFormStatus {
  INVALID = 'INVALID',
}

export type FormConfig = Record<string, [string, AbstractControlOptions['validators']?]>;

export enum FormInputType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  SELECT = 'select',
}

export interface CheckboxOption {
  label: string;
  id: string;
}

export type CheckboxOptionList = CheckboxOption[];

export type FormValue<T extends AbstractControl> = T extends AbstractControl<infer TValue> ? TValue : never;
